import { Component } from 'react';
import { reportToSentry } from '@/lib/sentry';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.reset = this.reset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const boundary = this.props.name || 'root';
    console.error('[ErrorBoundary:' + boundary + ']', error, info);
    reportToSentry(error, { boundary, componentStack: info && info.componentStack });
  }

  reset() {
    this.setState({ error: null });
  }

  render() {
    const { error } = this.state;
    const { children, name = 'this section', fallback } = this.props;
    if (!error) return children;
    if (typeof fallback === 'function') return fallback(error, this.reset);

    const isDev = import.meta.env.DEV;
    return (
      <div role="alert" style={{ padding: 20, margin: 16, background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, color: '#991b1b' }}>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>{'\u26A0\uFE0F '} Something went wrong in {name}.</div>
        <div style={{ fontSize: 12, marginBottom: 12, color: '#7f1d1d' }}>The rest of the app is still usable. Try reloading this section below.</div>
        {isDev && error && error.message && (
          <pre style={{ fontSize: 11, background: '#fff', padding: 10, borderRadius: 6, overflow: 'auto', color: '#450a0a', marginBottom: 12 }}>{String(error.message)}</pre>
        )}
        <button onClick={this.reset} style={{ background: '#dc2626', color: 'white', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
          Reload this section
        </button>
      </div>
    );
  }
}
